export default "__VITE_ASSET__BEUjOqCa__"